export const deliveryCriteria = {
  ORIGIN_PRICE: '할인 전 정상 판매 가격 기준',
  DISCOUNT_PRICE: '할인 후 판매 가격 기준',
};
